import React from 'react';
import styles from './footer.module.scss';

export const AppFooter = () => {
  return (
	<div className={styles.footer}>
	  © ФГБНУ Институт содержания и методов обучения
	</div>
  );
};
